module.exports = __webpack_public_path__ + "static/media/workflux-redefinePassword.3b87659e.svg";